import moment from 'moment'
import {
  calculateDate,
  FormateContractPayment,
  formatter,
  validateSpecialChar,
} from '../../../../utils'
import {
  CLONEDATA,
  CODESTEP2,
  CONTRACTSTATUS,
  CURRENTTAB,
  FEEAFTERVOUCHER,
  FORMACTIVED,
  NEWTAB,
  PACKAGES,
  PRODUCTINFORS,
  PRODUCTVALIDATION,
} from '../../healthInsurance/redux/action'
import {
  ActionTypes,
  CARINFO,
  CARPACKAGECODE,
  INPUTFIELDFORM,
  INSUREDFILTER,
  OWNERINFO,
} from './action'
import {autoInitialState} from './model'
import * as Effects from 'redux-saga/effects'
import {
  step2GetCarContractPackageByCode,
  step3GetObjectInsuredCarByID,
  step3GetObjectInsuredCarList,
} from '../apis'
import {step4GetContractByID} from '../../healthInsurance/apis'
import {CURRENCYINFOS} from '../../MotoInsurance/redux/actions'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWTABCAR', payload: tab}),
  modifyTab: (tab: CURRENTTAB) => ({type: 'MODIFYTABCAR', payload: tab}),
  activeFormAuto: (active: FORMACTIVED) => ({type: 'ACTIVEFORMAUTO', payload: active}),
  removeTabCar: (tab: string) => ({type: 'REMOVETABCAR', payload: tab}),
  addAutoInfos: (data: PRODUCTINFORS) => ({type: 'ADDAUTOINFORS', payload: data}),
  updateAutoStep1Infos: (data: CURRENCYINFOS) => ({
    type: 'UPDATEAUTOSTEP1INFOS',
    payload: data,
  }),
  saveCarPackageInsurances: (data: PACKAGES) => ({
    type: 'SAVECARPACKAGEINSURANCES',
    payload: data,
  }),
  saveCarPackageExtensions: (data: PACKAGES) => ({
    type: 'SAVECARPACKAGEEXTENSIONS',
    payload: data,
  }),
  getCarContractPackageByCode: (data: CARPACKAGECODE) => ({
    type: 'GETCARCONTRACTPACKAGEBYCODE',
    payload: data,
  }),
  saveCarContractPackageByCode: (data: any) => ({
    type: 'SAVECARCONTRACTPACKAGEBYCODE',
    payload: data,
  }),
  saveCarInfo: (data: any) => ({
    type: 'SAVECARINFO',
    payload: data,
  }),
  validateFormCar: (data: PRODUCTVALIDATION) => ({type: 'VALIDATEFORMCAR', payload: data}),
  getListCarInsured: (data: INSUREDFILTER) => ({
    type: 'GETLISTCARINSURED',
    payload: data,
  }),
  getListCarInsuredById: (data: any) => ({
    type: 'GETLISTCARINSUREDBYID',
    payload: data,
  }),
  saveListCarInsured: (data: any) => ({
    type: 'SAVELISTCARINSURED',
    payload: data,
  }),
  clearDataFormAuto: (data: CLONEDATA) => ({
    type: 'CLEARDATAFORMAUTO',
    payload: data,
  }),
  cloneDataFormAuto: (data: CLONEDATA) => ({
    type: 'CLONEDATAFORMAUTO',
    payload: data,
  }),
  getCarContractStep4ById: (data: any) => ({type: 'GETCARCONTRACTSTEP4BYID', payload: data}),
  saveCarContractStep4ById: (data: any) => ({type: 'SAVECARCONTRACTSTEP4BYID', payload: data}),
  updateCarCodeStep2: (data: CODESTEP2) => ({type: 'UPDATECARCODESTEP2', payload: data}),
  updateCarContractStatus: (data: CONTRACTSTATUS) => ({
    type: 'UPDATECARCONTRACTSTATUS',
    payload: data,
  }),
  updateCarInsuredOwner: (data: OWNERINFO) => ({
    type: 'UPDATECARINSUREDOWNER',
    payload: data,
  }),
  updateInputFieldForm: (data: INPUTFIELDFORM) => ({type: 'UPDATEINPUTFIELDFORM', payload: data}),
  updateCarInfo: (data: CARINFO) => ({type: 'UPDATECARINFO', payload: data}),
  updateFeeAfterVoucherAuto: (data: FEEAFTERVOUCHER) => ({
    type: 'UPDATEFEEAFTERVOUCHERAUTO',
    payload: data,
  }),
}

export const autoInsuReducer = (state = autoInitialState, action: ActionTypes) => {
  switch (action.type) {
    case 'ADDNEWTABCAR':
      const newTabState = JSON.parse(JSON.stringify(state))
      if (newTabState.length === 1 && newTabState[0].tabName == undefined) {
        newTabState[0].tabName = action.payload.tab
        newTabState[0].sellingContractId = action.payload.tab
        newTabState[0].customerCode = action.payload.customerCode
        newTabState[0].customerVersion = action.payload.customerVersion
        newTabState[0].contractType = action.payload.contractType
        newTabState[0].contractKind = action.payload.contractKind
        newTabState[0].originalContract = action.payload.originalContract
        newTabState[0].groupDomainCode = action.payload.groupDomainCode
        newTabState[0].form.activeForm = 1
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          groupDomainCode: action.payload.groupDomainCode,
          contractType: action.payload.contractType,
          contractKind: action.payload.contractKind,
          originalContract: action.payload.originalContract,
          packageExtension: undefined,
          packageInsurance: undefined,
          form: {
            activeForm: 1,
            formStatus: null,
            formData: {
              formAutoInsurancePlan: {
                businessProgramCode: null,
                productCode: 'AUTO_V',
                exploitingType: null,
                exploitingCode: null,
                typeOfIntroduction: null,
                introductionCode: null,
                curencyMoney: null,
                curencyFee: null,
                exchangeRate: '1',
                exchangeRateNote: null,
                business: null,
                businessName: null,
                currencyFeeChange: null,
                validateForm: null,
                tpa: null,
                tpaType: null,
                tpaFee: null,
                adjacentContractNumberLoss: null,
                adjacentContractNumber: null,
                paymentTimeType: null,
                calculationType: '0',
                nationality: null,
              },
              formAutoOfferFee: {
                id: null,
                vehicleOwner: null,
                code: null,
                name: null,
                address: null,
                startDate: moment().format('YYYY/MM/DD HH:mm'),
                licensePlate: null,
                chassisNumber: null,
                engineNumber: null,
                expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                manufacturingYear: moment().year().toString(),
                seat: '5',
                payload: '0',
                carCompany: null,
                carBrand: null,
                driverNumber: '0',
                capacity: '0',
                vehicleGroupsCode: null,
                purposeOfUseType: '2',
                price: null,
                amountCar: '1',
                packageCode: null,
                sumFee: null,
                validateForm: null,
                fieldInput: [],
                contractPackageBenefitChecked: null,
                contractPackageExtensionChecked: null,
                _sellingContractCarPackageBenefitDtos: null,
                _sellingContractCarPackageExtensionDtos: null,
              },
              formAutoListUser: {
                id: null,
                certType: null,
                certNumber: null,
                ownerCode: null,
                ownerVersion: null,
                oldContractCode: null,
                vehicleOwner: null,
                address: null,
                licensePlate: null,
                chassisNumber: null,
                engineNumber: null,
                startDate: moment().format('YYYY/MM/DD HH:mm'),
                expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                objectInsuredType: null,
                manufacturingYear: null,
                seat: null,
                payload: null,
                carCompany: null,
                carBrand: null,
                driverNumber: null,
                capacity: null,
                vehicleGroupsCode: null,
                engineType: '0',
                fuelType: '0',
                purposeOfUseType: null,
                price: null,
                code: null,
                sumFee: null,
                validateForm: null,
                listCar: null,
                payeeName: null,
                payeeNameIdentificationNumber: null,
                payeePhone: null,
                payeeEmail: null,
                contractPackageBenefitChecked: null,
                contractPackageExtensionChecked: null,
                payeesRelationsShip: null,
                fieldInput: [],
                nationality: null,
              },
              formAutoContract: {
                agency: null,
                contractType: null,
                contractNumber: null,
                originalCode: null,
                created: null,
                purchaseDate: null,
                startDate: null,
                expireDate: null,
                manager: null,
                totalPerson: null,
                sumFee: null,
                partyARepresentative: null,
                partyAPosition: null,
                partyBRepresentative: null,
                partyBPosition: null,
                partyBPhone: null,
                partyAPhone: null,
                partyAPowerOfAttorney: null,
                partyBPowerOfAttorney: null,
                partyBFax: null,
                proxy: null,
                bankCode: null,
                sumTax: null,
                taxType: null,
                bankNumber: null,
                _sellingContractPaymentScheduleDtos: null,
                _sellingContractExtraDataDtos: null,
                lossRatio: null,
                exploName: null,
                exploManager: null,
                exploitingType: null,
                validateForm: null,
                tsIncharge: null,
                pmIncharge: null,
                commission: '0',
                adminFee: '0',
                vatAdminFee: null,
                endorStartDate: null,
                endorExpireDate: null,
                endorNote: null,
                userReceiveMail: null,
                customerConfirmDate: null,
              },
            },
          },
        }
        newTabState.push(obj)
      }
      return newTabState
    case 'REMOVETABCAR':
      const removeTabState = JSON.parse(JSON.stringify(state))
      const tabRemoved = removeTabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'MODIFYTABCAR':
      const modifyTabState = JSON.parse(JSON.stringify(state))
      const currentModifyTab = modifyTabState.find(
        (o: any) => o.tabName == action.payload.currentTab
      )
      if (currentModifyTab) {
        currentModifyTab.sellingContractId = action.payload.newTabName
        currentModifyTab.customerCode = action.payload.customerCode
        currentModifyTab.customerVersion = action.payload.customerVersion
        currentModifyTab.groupDomainCode = action.payload.groupDomainCode
      }
      return modifyTabState
    case 'ADDAUTOINFORS':
      const addProductTabState = JSON.parse(JSON.stringify(state))
      const {key, value, tab, form} = action.payload
      let addProductTab = addProductTabState.find((o: any) => o.tabName == tab)
      if (addProductTab) {
        addProductTab.form.formData[form][key] = value
        // if (key == 'price') {
        //   if (value && value !== '' && typeof value == 'string') {
        //     let convert = value.replaceAll(',', '')
        //     if (!isNaN(parseInt(convert))) {
        //       let test = validateSpecialChar(value)
        //       if (!test) {
        //         addProductTab.form.formData[form][key] = formatter(parseInt(convert))
        //       } else addProductTab.form.formData[form][key] = formatter(parseInt(value))
        //     } else addProductTab.form.formData[form][key] = null
        //   } else if (typeof value == 'number') {
        //     addProductTab.form.formData[form][key] = formatter(value)
        //   }
        // }
        if (form == 'formAutoOfferFee') {
          if (key == 'startDate') {
            let dataCalculated = calculateDate(value, true)
            addProductTab.form.formData.formAutoOfferFee.expireDate = dataCalculated
          }
        }
        // if (form == 'formAutoListUser') {
        //   if (key == 'startDate') {
        //     let dataCalculated = calculateDate(value, true)
        //     addProductTab.form.formData.formAutoListUser.expireDate = dataCalculated
        //   }
        // }
      }
      return addProductTabState
    case 'UPDATEAUTOSTEP1INFOS':
      const autoCurrencyState = JSON.parse(JSON.stringify(state))
      const autoCurrencyTab = autoCurrencyState.find((o: any) => o.tabName == action.payload.tab)
      if (autoCurrencyTab) {
        autoCurrencyTab.form.formData.formAutoInsurancePlan.curencyMoney =
          action.payload.curencyMoney
        autoCurrencyTab.form.formData.formAutoInsurancePlan.curencyFee = action.payload.curencyFee
        autoCurrencyTab.form.formData.formAutoInsurancePlan.productCode = action.payload.groupDomain
        // autoCurrencyTab.form.formData.formAutoInsurancePlan.curencyFee = action.payload.groupDomains
      }
      return autoCurrencyState
    case 'ACTIVEFORMAUTO':
      const activeFormState = JSON.parse(JSON.stringify(state))
      let currentTab = activeFormState.find((o: any) => o.tabName == action.payload.tab)
      if (currentTab) {
        currentTab.form.activeForm = action.payload.form
      }
      return activeFormState
    case 'SAVECARPACKAGEINSURANCES':
      const packageInsuranceState = JSON.parse(JSON.stringify(state))
      const packageInsuranceTab = packageInsuranceState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (packageInsuranceTab) {
        packageInsuranceTab.packageInsurance = action.payload.data
        // packageInsuranceTab.form.formData.formPersonOfferFee.packageCode = null
      }
      return packageInsuranceState
    case 'SAVECARPACKAGEEXTENSIONS':
      const packageExtensionsState = JSON.parse(JSON.stringify(state))
      const packageExtensionsTab = packageExtensionsState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (packageExtensionsTab) {
        packageExtensionsTab.packageExtension = action.payload.data
      }
      return packageExtensionsState
    case 'SAVECARINFO':
      const carInfoState = JSON.parse(JSON.stringify(state))
      const carInfoStateTab = carInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (carInfoStateTab) {
        carInfoStateTab.form.formData.formAutoListUser.code = action.payload.data.packageCode
        carInfoStateTab.form.formData.formAutoListUser.id = action.payload.data.id
        carInfoStateTab.form.formData.formAutoListUser.certType = action.payload.data.certType
        carInfoStateTab.form.formData.formAutoListUser.certNumber = action.payload.data.certNumber
        carInfoStateTab.form.formData.formAutoListUser.objectInsuredType =
          action.payload.data.objectInsuredType
        carInfoStateTab.form.formData.formAutoListUser.vehicleGroupsCode =
          action.payload.data._sellingContractCarDtos[0].vehicleGroupsCode
        carInfoStateTab.form.formData.formAutoListUser.vehicleOwner =
          action.payload.data._sellingContractCarDtos[0].vehicleOwner
        carInfoStateTab.form.formData.formAutoListUser.address =
          action.payload.data._sellingContractCarDtos[0].address
        carInfoStateTab.form.formData.formAutoListUser.carCompany =
          action.payload.data._sellingContractCarDtos[0].carCompany
        carInfoStateTab.form.formData.formAutoListUser.carBrand =
          action.payload.data._sellingContractCarDtos[0].carBrand
        carInfoStateTab.form.formData.formAutoListUser.licensePlate =
          action.payload.data._sellingContractCarDtos[0].licensePlate
        carInfoStateTab.form.formData.formAutoListUser.chassisNumber =
          action.payload.data._sellingContractCarDtos[0].chassisNumber
        carInfoStateTab.form.formData.formAutoListUser.engineNumber =
          action.payload.data._sellingContractCarDtos[0].engineNumber
        carInfoStateTab.form.formData.formAutoListUser.manufacturingYear =
          action.payload.data._sellingContractCarDtos[0].manufacturingYear
        carInfoStateTab.form.formData.formAutoListUser.seat =
          action.payload.data._sellingContractCarDtos[0].seat
        carInfoStateTab.form.formData.formAutoListUser.payload =
          action.payload.data._sellingContractCarDtos[0].payload.toString()
        carInfoStateTab.form.formData.formAutoListUser.driverNumber =
          action.payload.data._sellingContractCarDtos[0].driverNumber.toString()
        carInfoStateTab.form.formData.formAutoListUser.capacity =
          action.payload.data._sellingContractCarDtos[0].capacity.toString()
        carInfoStateTab.form.formData.formAutoListUser.purposeOfUseType =
          action.payload.data._sellingContractCarDtos[0].purposeOfUseType
        carInfoStateTab.form.formData.formAutoListUser.price = formatter(
          action.payload.data._sellingContractCarDtos[0].price
        )
        carInfoStateTab.form.formData.formAutoListUser.startDate = moment(
          action.payload.data.startDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        carInfoStateTab.form.formData.formAutoListUser.expireDate = moment(
          action.payload.data.expireDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        carInfoStateTab.form.formData.formAutoListUser.sumFee = action.payload.data.sumFee
        carInfoStateTab.form.formData.formAutoListUser.sumTax = action.payload.data.sumTax
        carInfoStateTab.form.formData.formAutoListUser.feeCar = action.payload.data.sumFee
        carInfoStateTab.form.formData.formAutoListUser.payeeNameIdentificationNumber =
          action.payload.data.payeeNameIdentificationNumber
        carInfoStateTab.form.formData.formAutoListUser.payeeName = action.payload.data.payeeName
        carInfoStateTab.form.formData.formAutoListUser.payeesRelationsShip =
          action.payload.data.payeesRelationsShip
        action.payload.data._sellingContractCarBenefitDtos.map((o: any, i: number) => {
          o.approveInsuranceFee = o.insuranceFee
          o.approveIsDeductible = o.isDeductible == 0 ? 'Không' : 'Có'
          o.approveDeductible = o.deductible
          o.approveTax = o.sumTax
          o.approveSumInsured = o.sumInsured
          o.approveTax = o.tax
          o.id = i
        })
        action.payload.data._sellingContractCarExtensionDtos.map((o: any, i: number) => {
          o.id = i
        })

        carInfoStateTab.form.formData.formAutoListUser.contractPackageBenefitChecked =
          action.payload.data._sellingContractCarBenefitDtos
        carInfoStateTab.form.formData.formAutoListUser.contractPackageExtensionChecked =
          action.payload.data._sellingContractCarExtensionDtos
      }
      return carInfoState
    case 'GETCARCONTRACTPACKAGEBYCODE':
      return state
    case 'SAVECARCONTRACTPACKAGEBYCODE':
      const carContractPackageState = JSON.parse(JSON.stringify(state))
      const offerFeecarContractPackageTab = carContractPackageState.find(
        (o: any) => o.sellingContractId == action.payload.data.sellingContractId
      )
      if (offerFeecarContractPackageTab) {
        if (action.payload.form != 'formAutoListUser') {
          offerFeecarContractPackageTab.form.formData[action.payload.form].id =
            action.payload.data.id
        }
        offerFeecarContractPackageTab.form.formData[action.payload.form].packageCode =
          action.payload.data.packageCode
        offerFeecarContractPackageTab.form.formData[action.payload.form].name =
          action.payload.data.name
        offerFeecarContractPackageTab.form.formData[action.payload.form].code =
          action.payload.data.code
        offerFeecarContractPackageTab.form.formData[action.payload.form].manufacturingYear =
          action.payload.data.manufacturingYear
        offerFeecarContractPackageTab.form.formData[action.payload.form].seat =
          action.payload.data.seat
        offerFeecarContractPackageTab.form.formData[action.payload.form].contractPackageType =
          action.payload.data.contractPackageType
        offerFeecarContractPackageTab.form.formData[action.payload.form].startDate = moment(
          action.payload.data.startDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        if (action.payload.form == 'formAutoOfferFee') {
          offerFeecarContractPackageTab.form.formData[action.payload.form].expireDate = moment(
            action.payload.data.expireDate,
            'DD/MM/YYYY HH:mm'
          ).format('YYYY/MM/DD HH:mm')
        }
        if (action.payload.form == 'formAutoListUser') {
          offerFeecarContractPackageTab.form.formData[action.payload.form].expireDate = moment(
            action.payload.data.expireDate,
            'DD/MM/YYYY HH:mm'
          ).format('YYYY/MM/DD HH:mm')
        }
        offerFeecarContractPackageTab.form.formData[action.payload.form].sumFee =
          action.payload.data.sumFee
        offerFeecarContractPackageTab.form.formData[action.payload.form].amountCar =
          action.payload.data.amountCar
        offerFeecarContractPackageTab.form.formData[action.payload.form].vehicleGroupsCode =
          action.payload.data.vehicleGroupsCode
        offerFeecarContractPackageTab.form.formData[action.payload.form].carBrand =
          action.payload.data.carBrand
        offerFeecarContractPackageTab.form.formData[action.payload.form].carCompany =
          action.payload.data.carCompany
        offerFeecarContractPackageTab.form.formData[action.payload.form].purposeOfUseType =
          action.payload.data.purposeOfUseType
        offerFeecarContractPackageTab.form.formData[action.payload.form].price = formatter(
          action.payload.data.price
        )
        offerFeecarContractPackageTab.form.formData[action.payload.form].capacity =
          action.payload.data.capacity.toString()
        offerFeecarContractPackageTab.form.formData[action.payload.form].payload =
          action.payload.data.payload.toString()
        offerFeecarContractPackageTab.form.formData[action.payload.form].driverNumber =
          action.payload.data.driverNumber.toString()
        action.payload.data._sellingContractCarPackageBenefitDtos.map((o: any) => {
          o.approveIsDeductible = o.approveIsDeductible == 0 ? 'Không' : 'Có'
        })
        offerFeecarContractPackageTab.form.formData[
          action.payload.form
        ].contractPackageBenefitChecked = action.payload.data._sellingContractCarPackageBenefitDtos
        offerFeecarContractPackageTab.form.formData[
          action.payload.form
        ].contractPackageExtensionChecked =
          action.payload.data._sellingContractCarPackageExtensionDtos
      }
      return carContractPackageState
    case 'SAVELISTCARINSURED':
      const carListState = JSON.parse(JSON.stringify(state))
      const carListTab = carListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (carListTab) {
        if (action.payload.data && action.payload.data.items) {
          carListTab.form.formData.formAutoListUser.listCar = action.payload.data.items
        }
      }
      return carListState
    case 'VALIDATEFORMCAR':
      const validateState = JSON.parse(JSON.stringify(state))
      const validateTab = validateState.find((o: any) => o.tabName == action.payload.tab)
      if (validateTab) {
        validateTab.form.formData[action.payload.form].validateForm = action.payload.isError
      }
      return validateState
    case 'GETLISTCARINSURED':
      return state
    case 'CLONEDATAFORMAUTO':
      const cloneState = JSON.parse(JSON.stringify(state))
      const cloneTab = cloneState.find((o: any) => o.tabName == action.payload.tab)
      if (cloneTab) {
        cloneTab.form.formData[action.payload.form].id = null
        if ((action.payload.form = 'formAutoOfferFee')) {
          cloneTab.form.formData[action.payload.form].name = null
          cloneTab.form.formData[action.payload.form].code = null
        }
        if ((action.payload.form = 'formAutoListUser')) {
          cloneTab.form.formData[action.payload.form].vehicleOwner = null
          cloneTab.form.formData[action.payload.form].address = null
          cloneTab.form.formData[action.payload.form].licensePlate = null
          cloneTab.form.formData[action.payload.form].chassisNumber = null
          cloneTab.form.formData[action.payload.form].engineNumber = null
        }
      }
      return cloneState
    case 'CLEARDATAFORMAUTO':
      const cleanState = JSON.parse(JSON.stringify(state))
      const cleanTab = cleanState.find((o: any) => o.tabName == action.payload.tab)
      if (cleanTab) {
        for (const o in cleanTab.form.formData[action.payload.form]) {
          if (action.payload.form == 'formAutoOfferFee') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'packageCode' &&
              o !== 'fieldInput' &&
              o !== 'manufacturingYear' &&
              o !== 'seat' &&
              o !== 'payload' &&
              o !== 'driverNumber' &&
              o !== 'capacity' &&
              o !== 'amountCar'
            ) {
              cleanTab.form.formData[action.payload.form][o] = null
            }
            if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD HH:mm')
              cleanTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDate(date, true)
              cleanTab.form.formData.formAutoOfferFee.expireDate = dataCalculated
            }
            if (o == 'manufacturingYear')
              cleanTab.form.formData[action.payload.form][o] = moment().year().toString()
            if (o == 'seat') cleanTab.form.formData[action.payload.form][o] = '5'
            if (o == 'payload') cleanTab.form.formData[action.payload.form][o] = '0'
            if (o == 'driverNumber') cleanTab.form.formData[action.payload.form][o] = '0'
            if (o == 'capacity') cleanTab.form.formData[action.payload.form][o] = '0'
            if (o == 'amountCar') cleanTab.form.formData[action.payload.form][o] = '1'
          } else if (action.payload.form == 'formAutoListUser') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'listCar' &&
              o !== 'fieldInput' &&
              o !== 'certType' &&
              o !== 'objectInsuredType'
            ) {
              cleanTab.form.formData[action.payload.form][o] = null
            } else if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD HH:mm')
              cleanTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDate(date, true)
              cleanTab.form.formData[action.payload.form].expireDate = dataCalculated
            } else if (o == 'objectInsuredType') {
              cleanTab.form.formData[action.payload.form][o] = '1'
            }
          }
        }
      }
      return cleanState
    case 'GETCARCONTRACTSTEP4BYID':
      return state
    case 'SAVECARCONTRACTSTEP4BYID':
      const saveContractState = JSON.parse(JSON.stringify(state))
      const saveContractTab = saveContractState.find(
        (o: any) => o.sellingContractId == action.payload.id
      )
      if (saveContractTab) {
        saveContractTab.form.formData.formAutoContract.contractNumber =
          action.payload.contractNumber
        saveContractTab.form.formData.formAutoContract.created = moment(
          action.payload.createdDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formAutoContract.contractType = action.payload.contractType
        saveContractTab.form.formData.formAutoContract.startDate = moment(
          action.payload.startDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formAutoContract.purchaseDate = moment(
          action.payload.purchaseDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formAutoContract.manager = action.payload.manager
        saveContractTab.form.formData.formAutoContract.expireDate = moment(
          action.payload.expireDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formAutoContract.totalPerson = action.payload.amountPeople
        saveContractTab.form.formData.formAutoContract.adjacentContractNumber =
          action.payload.adjacentContractNumber
        saveContractTab.form.formData.formAutoContract.adjacentContractNumberLoss =
          action.payload.adjacentContractNumberLoss
        saveContractTab.form.formData.formAutoContract.partyARepresentative =
          action.payload.partyARepresentative
        saveContractTab.form.formData.formAutoContract.partyBRepresentative =
          action.payload.partyBRepresentative
        saveContractTab.form.formData.formAutoContract.partyAPowerOfAttorney =
          action.payload.partyAPowerOfAttorney
        saveContractTab.form.formData.formAutoContract.partyBPowerOfAttorney =
          action.payload.partyBPowerOfAttorney
        saveContractTab.form.formData.formAutoContract.partyAPosition =
          action.payload.partyAPosition
        saveContractTab.form.formData.formAutoContract.partyBFax = action.payload.partyBFax
        saveContractTab.form.formData.formAutoContract.partyBPhone = action.payload.partyBPhone
        saveContractTab.form.formData.formAutoContract.partyAPhone = action.payload.partyAPhone
        saveContractTab.form.formData.formAutoContract.partyBPosition =
          action.payload.partyBPosition
        saveContractTab.form.formData.formAutoContract.bankCode = action.payload.bankCode
        saveContractTab.form.formData.formAutoContract.bankNumber = action.payload.bankNumber
        saveContractTab.form.formData.formAutoContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
        saveContractTab.form.formData.formAutoContract._sellingContractExtraDataDtos =
          action.payload._sellingContractExtraDataDtos
        saveContractTab.form.formData.formAutoContract.sumFee = formatter(action.payload.sumFee)
        saveContractTab.form.formData.formAutoContract.sumTax = formatter(action.payload.sumTax)
        saveContractTab.form.formData.formAutoContract.taxType = action.payload.taxType
        saveContractTab.form.formData.formAutoContract.discount = action.payload.discount
          ? formatter(action.payload.discount)
          : 0
        if (action.payload.giftCode)
          saveContractTab.form.formData.formAutoContract.giftCode = action.payload.giftCode
      }
      return saveContractState
    case 'UPDATECARCODESTEP2':
      const updateCodeStep2State = JSON.parse(JSON.stringify(state))
      let updateCodeStep2Tab = updateCodeStep2State.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateCodeStep2Tab) {
        updateCodeStep2Tab.form.formData.formAutoOfferFee.id = action.payload.id
        updateCodeStep2Tab.form.formData.formAutoOfferFee.code = action.payload.code
      }
      return updateCodeStep2State
    case 'UPDATECARCONTRACTSTATUS':
      const contractStatusState = JSON.parse(JSON.stringify(state))
      let contractStatusTab = contractStatusState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (contractStatusTab) {
        contractStatusTab.form.formStatus = action.payload.status
      }
      return contractStatusState
    case 'UPDATECARINSUREDOWNER':
      const carInsuredOwnerState = JSON.parse(JSON.stringify(state))
      let carInsuredOwnersTab = carInsuredOwnerState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (carInsuredOwnersTab) {
        carInsuredOwnersTab.form.formData.formAutoListUser.vehicleOwner = action.payload.ownerName
        carInsuredOwnersTab.form.formData.formAutoListUser.address = action.payload.ownerAddress
      }
      return carInsuredOwnerState
    case 'UPDATEINPUTFIELDFORM':
      const updateInputFieldFormState = JSON.parse(JSON.stringify(state))
      let updateInputFieldFormTab = updateInputFieldFormState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateInputFieldFormTab) {
        updateInputFieldFormTab.form.formData[action.payload.form].fieldInput = [
          ...updateInputFieldFormTab.form.formData[action.payload.form].fieldInput,
          ...action.payload.data,
        ]
      }
      return updateInputFieldFormState
    case 'UPDATECARINFO':
      const updateCarInfoState = JSON.parse(JSON.stringify(state))
      let updateCarInfoTab = updateCarInfoState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateCarInfoTab) {
        updateCarInfoTab.form.formData.formAutoOfferFee.payload = action.payload.payload
        updateCarInfoTab.form.formData.formAutoOfferFee.price = action.payload.price
        updateCarInfoTab.form.formData.formAutoOfferFee.seat = action.payload.seat
        updateCarInfoTab.form.formData.formAutoOfferFee.manufacturingYear =
          action.payload.manufacturingYear
        updateCarInfoTab.form.formData.formAutoOfferFee.capacity = action.payload.capacity
        updateCarInfoTab.form.formData.formAutoOfferFee.flueType = action.payload.flueType
        updateCarInfoTab.form.formData.formAutoOfferFee.engineType = action.payload.engineType
      }
      return updateCarInfoState
    case 'UPDATEFEEAFTERVOUCHERAUTO':
      const updateFeeAfterVoucherAutoState = JSON.parse(JSON.stringify(state))
      let updateFeeAfterVoucherAutoTab = updateFeeAfterVoucherAutoState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateFeeAfterVoucherAutoTab) {
        updateFeeAfterVoucherAutoTab.form.formData.formAutoContract.sumFee = action.payload.sumFee
        updateFeeAfterVoucherAutoTab.form.formData.formAutoContract.sumTax = action.payload.sumTax
        updateFeeAfterVoucherAutoTab.form.formData.formAutoContract.discount =
          action.payload.discount
        updateFeeAfterVoucherAutoTab.form.formData.formAutoContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
      }
      return updateFeeAfterVoucherAutoState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETCARCONTRACTPACKAGEBYCODE', function* getDataOfferFeeByCodeSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetCarContractPackageByCode, action.payload)
      if (response && !response.isError) {
        let param = {
          form: action.payload.form,
          data: response.data,
        }
        yield put(actions.saveCarContractPackageByCode(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETLISTCARINSURED', function* getListCarInsured(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredCarList, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListCarInsured(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETLISTCARINSUREDBYID', function* getListCarInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredCarByID, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveCarInfo(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETCARCONTRACTSTEP4BYID', function* getCarContractStep4ByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step4GetContractByID, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveCarContractStep4ById(response.data))
      }
    } catch (error) {
      return
    }
  })
}
